import { Dispatch, useCallback, SetStateAction } from 'react'
import { filterBreadsByCategory, filterBreadsByKeyword, filterBreadsByPage } from 'lib/filter'
import { BreadType } from 'types/bread'
import { CategoryType } from 'types/category'
import { StockType } from 'types/stock'

const useSelectCategory = (
  breads: BreadType[],
  categories: CategoryType[],
  keyword: string,
  setCategoryName: Dispatch<SetStateAction<string>>,
  setBreadList: Dispatch<SetStateAction<BreadType[]>>,
  page: 'released' | 'unreleased',
  stocks: StockType[]
) => {
  return useCallback(
    (value: string) => {
      if (value === '' && keyword === '') {
        // カテゴリーが未選択かつキーワードも未選択であれば初期値に戻す
        const filteredBreadsByPage = filterBreadsByPage(page, breads, stocks)
        setBreadList([...filteredBreadsByPage])
      } else if (value === '' && keyword !== '') {
        // カテゴリーが未選択でキーワードのフィルタリング
        const filteredBreadsByPage = filterBreadsByPage(page, breads, stocks)
        const filteredBreadsByKeyword = filterBreadsByKeyword(keyword, filteredBreadsByPage)
        setBreadList([...filteredBreadsByKeyword])
      } else {
        // カテゴリでフィルターした後にキーワードでフィルタリング
        const filteredBreadsByPage = filterBreadsByPage(page, breads, stocks)
        const filteredBreadsByCategory = filterBreadsByCategory(value, categories, filteredBreadsByPage)
        const filteredBreadsByKeyword = filterBreadsByKeyword(keyword, filteredBreadsByCategory)
        setBreadList([...filteredBreadsByKeyword])
      }
      setCategoryName(value)
    },
    [breads, categories, keyword, setCategoryName, setBreadList, page, stocks]
  )
}

export default useSelectCategory
